module.exports = __webpack_public_path__ + "static/media/article-placeholder.8a390162.jpg";